import { getFilterValues, setFilterValues, } from '@/compositions/useKonvaFilterValues';
import { HistoryType } from '@/types/history';
import { Tools } from '@/types/tools';
import Konva from 'konva';
import { applyShapeHistory, getShapeHistoryObject, } from './useStickerHistoryHelper';
export function getHistoryObject(source, obj, type, meta) {
    try {
        let historyObject;
        switch (source) {
            case Tools.CROP:
                historyObject = {
                    x: obj.x(),
                    y: obj.y(),
                    width: obj.width(),
                    height: obj.height(),
                    rotation: obj.rotation(),
                    scale: obj.scale(),
                    blob: undefined,
                };
                if (type === HistoryType.REPLACE) {
                    if (meta === null || meta === void 0 ? void 0 : meta.blob) {
                        historyObject.blob = meta.blob;
                    }
                    else {
                        historyObject.blob = obj.toDataURL({
                            mimeType: 'image/png',
                        });
                    }
                }
                break;
            case Tools.TEXT:
                if (obj) {
                    historyObject = {
                        x: obj.x(),
                        y: obj.y(),
                        text: obj.getText().text(),
                        width: obj.width(),
                        height: obj.height(),
                        rotation: obj.rotation(),
                        fontFamily: obj.getText().fontFamily(),
                        fontSize: obj.getText().fontSize(),
                        lineHeight: obj.getText().lineHeight(),
                        align: obj.getText().align(),
                        verticalAlign: obj.getText().verticalAlign(),
                        draggable: obj.draggable(),
                        backgroundColor: obj.getTag().fill(),
                        fill: obj.getText().fill(),
                        scale: obj.scale(),
                    };
                }
                break;
            case Tools.STICKERS:
                if (obj) {
                    historyObject = getShapeHistoryObject(obj, meta);
                }
                break;
            case Tools.BRUSH:
                if (obj) {
                    historyObject = {
                        stroke: obj.stroke(),
                        strokeWidth: obj.strokeWidth(),
                        lineCap: obj.lineCap(),
                        globalCompositeOperation: obj.globalCompositeOperation(),
                        points: obj.points(),
                        lineJoin: obj.lineJoin(),
                        opacity: obj.opacity(),
                    };
                }
                break;
            case Tools.ADJUSTMENTS:
            case Tools.FILTERS:
                historyObject = {
                    filters: getFiltersData(obj),
                };
                break;
        }
        return historyObject;
    }
    catch (error) {
        return {};
    }
}
function getFiltersData(obj) {
    const filterNames = [];
    let filters = obj.filters();
    if (!filters)
        filters = [];
    filters.forEach(f => {
        if (!f.name.includes('customFilter')) {
            filterNames.push(f.name);
        }
        else {
            filterNames.push(f);
        }
    });
    filters = filters.filter(f => !f.name.includes('customFilter'));
    const values = getFilterValues(obj, filters);
    return {
        filters: filterNames,
        values,
    };
}
export function applyHistory(object, source, history) {
    var _a;
    switch (source) {
        case Tools.STICKERS:
            applyShapeHistory(object, history);
            break;
        case Tools.CROP:
            object.setAttrs({
                x: history.x,
                y: history.y,
                width: history.width,
                height: history.height,
                rotation: history.rotation,
                scale: history.scale,
                opacity: history.opacity || 1,
            });
            break;
        case Tools.TEXT:
            object.setAttrs({
                x: history.x,
                y: history.y,
                width: history.width,
                height: history.height,
                draggable: history.draggable,
                rotation: history.rotation,
                scale: history.scale,
            });
            object.getText().setAttrs({
                fill: history.fill,
                fontFamily: history.fontFamily,
                fontSize: history.fontSize,
                lineHeight: history.lineHeight,
                align: history.align,
                verticalAlign: history.verticalAlign,
                width: history.width,
                height: history.height,
                text: history.text,
            });
            object.getTag().setAttrs({
                fill: history.backgroundColor,
            });
            break;
        case Tools.FILTERS:
        case Tools.ADJUSTMENTS:
            if ((_a = history.filters) === null || _a === void 0 ? void 0 : _a.filters) {
                const filters = [];
                history.filters.filters.forEach((f) => {
                    if (f.name) {
                        filters.push(f);
                    }
                    else {
                        filters.push(Konva.Filters[f]);
                    }
                });
                object.filters(filters);
                setFilterValues(object, history.filters.values);
            }
            break;
    }
}
